import { Controller } from '@hotwired/stimulus'

// Ashby's embed script empties the container and appends its iframe, so
// the skeleton lives beside the container and is dropped once the iframe
// has loaded.
export default class extends Controller {
  static targets = ['embed', 'skeleton']

  connect() {
    const iframe = this.embedTarget.querySelector('iframe')

    if (iframe) {
      this.#watch(iframe)
    } else {
      this.observer = new MutationObserver(this.#handleMutation.bind(this))
      this.observer.observe(this.embedTarget, { childList: true })
    }
  }

  disconnect() {
    this.observer?.disconnect()
  }

  #handleMutation() {
    const iframe = this.embedTarget.querySelector('iframe')
    if (!iframe) return

    this.observer.disconnect()
    this.#watch(iframe)
  }

  #watch(iframe) {
    iframe.addEventListener('load', () => this.#reveal(), { once: true })
  }

  #reveal() {
    this.skeletonTarget.remove()
    delete this.element.dataset.loading
  }
}
